<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="false"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <Head></Head>
                    <div class="mobile_container">
                        <div
                            class="list_item_card"
                            :class="['list_item_card', { 'is-resize': item.isDrag }]"
                            v-for="(item, index) in navList"
                            :key="index"
                            :style="{ width: item.width, height: item.height + 'px' }"
                            @touchstart="onStartResuze($event, index, item.isDrag)"
                            @touchmove="onResize($event, index, item.isDrag)"
                            @touchend="onStopResize"
                        >
                            <div class="list_item_title">
                                <span class="title">{{ item.title }}</span>
                                <van-popover
                                    v-model="item.popoverShow"
                                    :ref="'top_operator_popover' + index"
                                    class="top_operator_popover"
                                    placement="bottom-end"
                                    trigger="click"
                                >
                                    <div class="top_operator_list">
                                        <li
                                            v-for="operateItem in operatorList"
                                            :key="operateItem.type"
                                            @click="handleClickOperate(operateItem, item, index)"
                                        >
                                            <span class="icon_wrap"
                                                ><i :class="['iconfont', operateItem.icon]"></i
                                            ></span>
                                            <span>{{ operateItem.title }}</span>
                                        </li>
                                    </div>
                                    <template #reference>
                                        <span class="list_item_more"></span>
                                    </template>
                                </van-popover>
                            </div>
                            <ul>
                                <li v-for="(childItem, childIndex) in item.children" :key="childIndex">
                                    <div class="icon_wrap">
                                        <span
                                            v-if="item.isEdit"
                                            class="operate_icon delete_icon"
                                            @click="handleClickDeleteCardItem(item, childItem, childIndex)"
                                            ><i class="iconfont icon-jianqu"></i
                                        ></span>
                                    </div>
                                    <span>{{ childItem.title }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="more_set_icon" @click="handleClickSet">
                            <span>设置卡片</span>
                        </div>
                    </div>
                    <van-popup v-model="setPopupVisible" position="bottom" :style="{ height: '83%' }" class="set_popup">
                        <div class="set_popup_wrap">
                            <div class="set_popup_title">
                                <van-search
                                    v-model="searchForm.keyword"
                                    placeholder="搜索组件"
                                    @clear="onSearch"
                                    @search="onSearch"
                                >
                                </van-search>
                                <van-button plain type="info">确定</van-button>
                            </div>
                            <div class="set_popup_content">
                                <div class="set_popup_card">
                                    <p class="set_item_title">已添加应用</p>
                                    <ul>
                                        <li v-for="(item, index) in addApplications" :key="index">
                                            <span class="icon_wrap"
                                                ><i :class="['iconfont', item.icon]"></i
                                                ><span
                                                    class="operate_icon delete_icon"
                                                    @click="handleClickDeleteItem(item, index)"
                                                    ><i class="iconfont icon-jianqu"></i></span
                                            ></span>
                                            <span>{{ item.title }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    class="set_popup_card"
                                    v-for="(cardItem, cardIndex) in allApplications"
                                    :key="cardIndex"
                                >
                                    <p class="set_item_title">{{ cardItem.title }}</p>
                                    <ul>
                                        <li v-for="(item, index) in cardItem.children" :key="index">
                                            <span class="icon_wrap"
                                                ><i :class="['iconfont', item.icon]"></i
                                                ><span
                                                    class="operate_icon add_icon"
                                                    @click="handleClickAddItem(cardIndex, item, index)"
                                                    ><i class="iconfont icon-a-tianjiamiaobian"></i></span
                                            ></span>
                                            <span>{{ item.title }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </van-popup>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                </div>
            </template>
        </PullContainer>
    </div>
</template>
<script>
import { Dialog } from "vant";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import Head from "@/components/mComponents/Head.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
export default {
    name: "mobileWorkBench",
    data() {
        return {
            tabBarList: [
                {
                    icon: "icon-gongzuotai_weixuanzhong1",
                    activeIcon: "icon-gongzuotai_xuanzhong",
                    routerName: "mobileWorkBench",
                    title: "工作台",
                },
                {
                    icon: "icon-renwu_weixuanzhong",
                    activeIcon: "icon-renwu_xuanzhong",
                    routerName: "mobileTodo",
                    title: "待办",
                },
                {
                    icon: "icon-xiaoxi",
                    activeIcon: "icon-xiaoxi1",
                    routerName: "Message",
                    title: "消息",
                },
                {
                    icon: "icon-gengduogongneng_weixuanzhong",
                    activeIcon: "icon-gengduogongneng_xuanzhong",
                    routerName: "mobileAllFunctions",
                    title: "全部",
                },
            ],
            tabBarActive: 0,
            navList: [
                {
                    title: "协同办公",
                    children: [
                        { title: "日程表", name: "", path: "", icon: "" },
                        { title: "通讯录", name: "", path: "", icon: "" },
                        { title: "系统公告", name: "", path: "", icon: "" },
                        { title: "勤务表", name: "", path: "", icon: "" },
                        { title: "报销申请", name: "", path: "", icon: "" },
                    ],
                    popoverShow: false,
                    width: "100%",
                    height: 106,
                    isDrag: true,
                },
                {
                    title: "客户管理",
                    children: [
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户档案", name: "", path: "", icon: "" },
                        { title: "商机管理", name: "", path: "", icon: "" },
                        { title: "订单管理", name: "", path: "", icon: "" },
                        { title: "开票申请", name: "", path: "", icon: "" },
                        { title: "退款申请", name: "", path: "", icon: "" },
                        { title: "提成申请", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                    ],
                    popoverShow: false,
                    width: "100%",
                    height: 222,
                    isDrag: true,
                },
            ],
            operatorList: [
                { type: "delete", title: "删除卡片", icon: "" },
                { type: "set", title: "设置卡片", icon: "" },
                { type: "edit", title: "编辑", icon: "" },
            ],
            setPopupVisible: false, // 设置卡片弹框
            searchForm: {
                keyword: "",
            },
            addApplications: [
                { title: "客户公海", name: "", path: "", icon: "" },
                { title: "客户档案", name: "", path: "", icon: "" },
                { title: "商机管理", name: "", path: "", icon: "" },
                { title: "订单管理", name: "", path: "", icon: "" },
                { title: "开票申请", name: "", path: "", icon: "" },
                { title: "退款申请", name: "", path: "", icon: "" },
                { title: "提成申请", name: "", path: "", icon: "" },
            ], // 已添加的应用
            allApplications: [
                {
                    title: "协同办公",
                    children: [
                        { title: "日程表", name: "", path: "", icon: "" },
                        { title: "通讯录", name: "", path: "", icon: "" },
                        { title: "系统公告", name: "", path: "", icon: "" },
                        { title: "勤务表", name: "", path: "", icon: "" },
                        { title: "报销申请", name: "", path: "", icon: "" },
                    ],
                },
                {
                    title: "客户管理",
                    children: [
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户档案", name: "", path: "", icon: "" },
                        { title: "商机管理", name: "", path: "", icon: "" },
                        { title: "订单管理", name: "", path: "", icon: "" },
                        { title: "开票申请", name: "", path: "", icon: "" },
                        { title: "退款申请", name: "", path: "", icon: "" },
                        { title: "提成申请", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                    ],
                },
            ], // 全部应用
            isResizing: false, // 是否能改变大小
            initialX: 0,
            initialY: 0,
            initialWidth: 0, // 初始宽度
            initialHeight: 0, // 初始高度
        };
    },
    mounted() {},
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                setTimeout(() => {
                    this.$refs.pullContainerRef.pullDownLoadingEnd(11);
                }, 3000);
            }
        },
        onStartResuze(event, index, isDrag) {
            if (!isDrag) return;
            this.isResizing = true;
            this.initialX = event.clientX || event.touches[0].clientX;
            this.initialY = event.clientY || event.touches[0].clientY;
            // this.initialWidth = this.elementWidth;
            this.initialHeight = this.navList[index].height;
        },
        onResize(event, index, isDrag) {
            if (!isDrag) return;
            if (!this.isResizing) return;

            const currentX = event.clientX || event.touches[0].clientX;
            const currentY = event.clientY || event.touches[0].clientY;

            const deltaX = currentX - this.initialX;
            const deltaY = currentY - this.initialY;

            // this.navList[index].width = Math.max(this.initialWidth + deltaX, 80); // 最小宽度为50px
            this.navList[index].height = Math.max(this.initialHeight + deltaY, 80); // 最小高度为50px
        },
        onStopResize() {
            this.isResizing = false;
        },
        // 操作项
        handleClickOperate(item, cardItem, cardIndex) {
            const type = item.type;
            switch (type) {
                case "delete":
                    Dialog.confirm({
                        title: cardItem.title,
                        message: "你确定要删除该卡片吗？",
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                    }).then(() => {
                        console.log("删除");
                    });
                    break;
                case "set":
                    this.setPopupVisible = true;
                    break;
                case "edit":
                    this.$set(cardItem, "isEdit", true);
                    this.$set(cardItem, "popoverShow", false);
                    break;
            }
        },
        // 设置卡片
        handleClickSet() {
            this.setPopupVisible = true;
        },
        // 删除卡片中的某个应用
        handleClickDeleteCardItem(cardItem, item, index) {
            cardItem.children.splice(index, 1);
        },
        // 搜索
        onSearch() {},
        // 设置弹框页面删除已添加的应用
        handleClickDeleteItem(item, index) {
            this.addApplications.splice(index, 1);
        },
        // 设置弹框页面添加到应用中
        handleClickAddItem(cardIndex, item, index) {
            this.addApplications.push(item);
        },
    },
    components: {
        PullContainer,
        Head,
        FooterTabbar,
    },
};
</script>

<style lang="scss" scoped>
.mobile_container {
    padding: 8px 16px;
}
.list_item_card {
    border-radius: 6px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 8px;
    &.is-resize {
        cursor: s-resize;
    }
    .list_item_title {
        padding: 10px 0 10px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }
        .list_item_more {
            display: inline-block;
            position: relative;
            padding: 3px 7px;
            width: 23px;
            height: 9px;
            border-radius: 3px;
            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 3px;
                width: 3px;
                height: 3px;
                opacity: 1;
                background: rgba(204, 204, 204, 1);
                border-radius: 50%;
            }
            &::before {
                left: 7px;
            }
            &::after {
                right: 7px;
            }
        }
    }
    ul {
        padding-bottom: 6px;
        display: flex;
        flex-wrap: wrap;
        li {
            width: 20%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 4px;
            .icon_wrap {
                width: 32px;
                height: 32px;
                opacity: 1;
                border-radius: 6px;
                background: rgba(204, 204, 204, 1);
                position: relative;
                .operate_icon {
                    position: absolute;
                    top: -7px;
                    right: -7px;
                    width: 14px;
                    height: 14px;
                    .iconfont {
                        font-size: 14px;
                    }
                }
                .add_icon {
                    color: rgba(42, 130, 228, 1);
                }
                .delete_icon {
                    color: rgba(204, 204, 204, 1);
                }
            }
            & > span {
                margin-top: 4px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(102, 102, 102, 1);
            }
        }
    }
}
.top_operator_list {
    width: 104px;
    padding: 4px 0;
    li {
        list-style: none;
        width: 100%;
        height: 38px;
        line-height: 38px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        .icon_wrap {
            width: 16px;
            height: 16px;
            opacity: 1;
            background: rgba(204, 204, 204, 1);
        }
        span:last-child {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
        }
        &:active {
            background-color: rgba(153, 153, 153, 0.04);
        }
    }
}
.more_set_icon {
    margin-top: 16px;
    text-align: center;
    span {
        padding: 2px 4px;
        border-radius: 6px;
        background: rgba(204, 204, 204, 0.5);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        user-select: none; /* 兼容所有浏览器的设置 */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }
}
.set_popup {
    border-radius: 6px 6px 0px 0px;
    .set_popup_wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .set_popup_content {
            flex: 1;
            overflow-y: auto;
            padding: 0 16px;
        }
    }
    .set_popup_title {
        padding: 10px 16px;
        display: flex;
        align-items: center;
        gap: 12px;
        .van-search {
            flex: 1;
            padding: 0;
            .van-search__content {
                background-color: rgba(243, 243, 243, 1);
                border-radius: 6px;
            }
            .van-cell {
                padding: 4px 8px 4px 0;
            }
            ::v-deep {
                .van-field__left-icon {
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
        .van-button {
            height: 32px;
            padding: 0;
            border: 0;
            color: rgba(42, 130, 228, 1);
        }
    }
    .set_popup_card {
        margin-bottom: 16px;
        .set_item_title {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(0, 0, 0, 1);
            padding-bottom: 5px;
            position: relative;
            &::after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 1px;
                border-radius: 1px;
                background-color: rgba(204, 204, 204, 1);
            }
        }
        ul {
            display: flex;
            flex-wrap: wrap;
            li {
                width: 20%;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 18px;
                .icon_wrap {
                    width: 32px;
                    height: 32px;
                    opacity: 1;
                    border-radius: 6px;
                    background: rgba(204, 204, 204, 1);
                    position: relative;
                    .operate_icon {
                        position: absolute;
                        top: -7px;
                        right: -7px;
                        width: 14px;
                        height: 14px;
                        .iconfont {
                            font-size: 14px;
                        }
                    }
                    .add_icon {
                        color: rgba(42, 130, 228, 1);
                    }
                    .delete_icon {
                        color: rgba(204, 204, 204, 1);
                    }
                }
                & > span {
                    margin-top: 4px;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
}
</style>
